
import React from 'react';

interface SellCarLayoutProps {
  children: React.ReactNode;
}

const SellCarLayout = ({ children }: SellCarLayoutProps) => {
  return (
    <main>
      {children}
    </main>
  );
};

export default SellCarLayout;
